import React from 'react';
import { motion } from 'framer-motion';
import { LumaLogoIcon } from '../LumaLogo';

const COLS = 10;
const ROWS = 6;

export const FinalCTA = () => {
  const scrollToBooking = () => {
    const el = document.querySelector('#booking');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      id="cta"
      data-testid="final-cta-section"
      className="relative py-32 lg:py-44 px-6 overflow-hidden"
      style={{ background: '#0A0A0A' }}
    >
      {/* LED Grid miniature */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none opacity-30">
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: `repeat(${COLS}, 1fr)`,
            gridTemplateRows: `repeat(${ROWS}, 1fr)`,
            width: '100%',
            height: '100%',
          }}
        >
          {Array.from({ length: COLS * ROWS }, (_, i) => (
            <div
              key={i}
              style={{
                borderRight: '1px solid rgba(139,92,246,0.06)',
                borderBottom: '1px solid rgba(139,92,246,0.06)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
              }}
            >
              <div
                className="animate-pulse"
                style={{
                  width: '2px',
                  height: '2px',
                  borderRadius: '50%',
                  backgroundColor: 'rgba(139,92,246,0.3)',
                  animationDelay: `${(i * 0.07) % 3}s`,
                  animationDuration: `${2 + (i % 3)}s`,
                }}
              />
            </div>
          ))}
        </div>
      </div>

      {/* Large glow */}
      <div
        className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 pointer-events-none"
        style={{
          width: '700px',
          height: '700px',
          borderRadius: '50%',
          background: 'radial-gradient(circle, rgba(139,92,246,0.12) 0%, transparent 60%)',
          filter: 'blur(60px)',
        }}
      />

      <div className="relative z-10 max-w-4xl mx-auto text-center">
        {/* Logo */}
        <motion.div
          initial={{ opacity: 0, scale: 0.8 }}
          whileInView={{ opacity: 1, scale: 1 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8, ease: 'easeOut' }}
          className="flex justify-center mb-10 animate-float"
          data-testid="cta-logo"
        >
          <LumaLogoIcon size={64} />
        </motion.div>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.2, duration: 0.7 }}
          className="text-xs font-manrope tracking-[0.3em] uppercase text-luma-purple mb-6"
          data-testid="cta-label"
        >
          Ready?
        </motion.p>

        <motion.h2
          initial={{ opacity: 0, y: 30 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.35, duration: 0.9, ease: 'easeOut' }}
          className="font-outfit font-black text-4xl sm:text-5xl lg:text-6xl xl:text-7xl leading-none tracking-tighter text-white mb-8"
          data-testid="cta-headline"
        >
          Turn Your Event Into
          <br />
          <span className="gradient-text">Something People</span>
          <br />
          Talk About.
        </motion.h2>

        <motion.p
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.55, duration: 0.7 }}
          className="font-manrope text-base text-white/45 max-w-lg mx-auto mb-12 leading-relaxed"
          data-testid="cta-subtext"
        >
          One installation. Infinite impact. Let's build something unforgettable together.
        </motion.p>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ delay: 0.7, duration: 0.7 }}
        >
          <button
            data-testid="cta-book-btn"
            onClick={scrollToBooking}
            className="btn-primary text-white font-manrope font-bold text-base px-12 py-5 rounded-full tracking-wide animate-pulse-glow inline-flex items-center gap-3"
          >
            Book Luma
          </button>
        </motion.div>
      </div>
    </section>
  );
};

export default FinalCTA;
